import { FormattedMessage } from "react-intl"

const ErrorFallbackMessage = () => {
    const handleRefresh = () => window.location.reload();

    return (
        <div className="error-msg">
            <p className="h3">
                <FormattedMessage id="common.somethingWentWrong" />
            </p>
            <button className="btn primary btn--small" onClick={handleRefresh}>
                <FormattedMessage id="common.refreshTheApp" />
            </button>
        </div>
    );
};

export default ErrorFallbackMessage
